import { lazy } from 'react';

const SupportPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/support',
      component: lazy(() => import('./SupportPage')),
    },
  ],
};

export default SupportPageConfig;
